import React, { useState } from "react";
import { Link } from "react-router-dom";
import { trackRentalCarReservation } from "../helper/facebookPixel";

const RentalCarCard = ({ car }) => {
  const [imageIndex, setImageIndex] = useState(0);

  const {
    slug,
    title,
    subtitle,
    year,
    fuel,
    transmission,
    seats,
    features,
    images,
    amovensUrl,
    dailyRate,
  } = car;

  const mainImage = images?.[imageIndex] || images?.[0];
  const hasMultipleImages = images && images.length > 1;

  const handlePrevImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <Link to={`/alquiler/${slug}`} className="rental-car-card">
      {/* Image Gallery */}
      <div className="rental-car-card__gallery">
        <img
          src={mainImage}
          alt={title}
          className="rental-car-card__image"
          loading="lazy"
        />

        {/* Daily Rate Badge */}
        {dailyRate && (
          <div className="rental-car-card__badge">
            <span>desde {dailyRate}€/día</span>
          </div>
        )}

        {/* Image Navigation */}
        {hasMultipleImages && (
          <>
            <button
              className="rental-car-card__nav rental-car-card__nav--prev"
              onClick={handlePrevImage}
              aria-label="Imagen anterior"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <button
              className="rental-car-card__nav rental-car-card__nav--next"
              onClick={handleNextImage}
              aria-label="Siguiente imagen"
            >
              <i className="fas fa-chevron-right"></i>
            </button>

            {/* Image Indicators */}
            <div className="rental-car-card__indicators">
              {images.map((_, idx) => (
                <span
                  key={idx}
                  className={`rental-car-card__indicator ${idx === imageIndex ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setImageIndex(idx);
                  }}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {/* Content */}
      <div className="rental-car-card__content">
        {/* Header */}
        <div className="rental-car-card__header">
          <h3 className="rental-car-card__title">{title}</h3>
          <span className="rental-car-card__subtitle">{subtitle}</span>
        </div>

        {/* Specs */}
        <div className="rental-car-card__specs">
          <div className="rental-car-card__spec">
            <i className="fas fa-cog"></i>
            <span>{transmission}</span>
          </div>
          <div className="rental-car-card__spec">
            <i className="fas fa-users"></i>
            <span>{seats}</span>
          </div>
        </div>

        {/* Features Preview as compact bubbles */}
        {features?.length > 0 && (
          <div className="rental-car-card__features">
            {features.slice(0, 3).map((feature, idx) => (
              <span key={idx} className="rental-car-card__feature">{feature}</span>
            ))}
            {features.length > 3 && (
              <span className="rental-car-card__feature rental-car-card__feature--more">+{features.length - 3}</span>
            )}
          </div>
        )}

        {/* Actions */}
        <div className="rental-car-card__actions">
          <span className="rental-car-card__btn rental-car-card__btn--details">
            <i className="fas fa-info-circle"></i>
            Ver Detalles
          </span>
          <a
            href={amovensUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="rental-car-card__btn rental-car-card__btn--book"
            onClick={(e) => {
              e.stopPropagation();
              trackRentalCarReservation(title, slug, amovensUrl);
            }}
          >
            <i className="fas fa-external-link-alt"></i>
            Reservar
          </a>
        </div>
      </div>
    </Link>
  );
};

export default RentalCarCard;
